export enum AmericanFootballDefensiveReturnAttribute {
  Fumble = 660,
  Interception = 661,
  Kickoff = 662,
  Punt = 663,
}
